var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qd-login-v3-page"},[_c('div',{ref:"staticRoot",staticClass:"qd-login-v3-root"}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginVisible),expression:"loginVisible"}],staticClass:"qd-login-v3-overlay",attrs:{"id":_vm.loginContainerId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }